import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Newspaper, TrendUp, TrendDown, Eye } from "@phosphor-icons/react";

const IMPACT = {
    positive: { color: "text-fp-success", Icon: TrendUp, label: "Positive" },
    negative: { color: "text-fp-terracotta", Icon: TrendDown, label: "Negative" },
    watch: { color: "text-fp-saffron", Icon: Eye, label: "Watch" },
};

export default function NewsWidget({ scope }) {
    // scope: "group" | "sector:{id}" | "country:{code}"
    const [items, setItems] = useState(null);

    useEffect(() => {
        let url;
        if (scope === "group") url = "/intel/group";
        else if (scope.startsWith("sector:")) url = `/intel/sector/${scope.split(":")[1]}`;
        else if (scope.startsWith("country:")) url = `/intel/country/${scope.split(":")[1]}`;
        else return;
        client.get(url).then((r) => setItems(r.data.news || [])).catch(() => setItems([]));
    }, [scope]);

    return (
        <div className="bg-white border border-fp-border h-full flex flex-col" data-testid="news-widget">
            <div className="px-5 py-3 border-b border-fp-border flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Newspaper size={14} className="text-fp-plum" weight="fill" />
                    <div className="font-sans text-[10px] uppercase tracking-[0.25em] text-fp-secondary">Market & Geo Signal</div>
                </div>
                <div className="font-mono text-[9px] text-fp-muted uppercase">Feb'26</div>
            </div>
            <div className="flex-1 divide-y divide-fp-border">
                {items === null && (
                    <div className="p-4 space-y-2">
                        <div className="h-2 bg-fp-border w-3/4 animate-pulse" />
                        <div className="h-2 bg-fp-border w-2/3 animate-pulse" />
                    </div>
                )}
                {items && items.length === 0 && (
                    <div className="p-4 font-sans text-xs text-fp-muted">No active signals for this scope.</div>
                )}
                {items && items.map((n, i) => {
                    const imp = IMPACT[n.impact] || IMPACT.watch;
                    const Icon = imp.Icon;
                    return (
                        <div key={i} className="p-4 hover:bg-fp-bg transition-colors">
                            <div className="flex items-start gap-2.5">
                                <Icon size={12} className={`shrink-0 mt-0.5 ${imp.color}`} weight="fill" />
                                <div className="min-w-0">
                                    <div className="font-sans text-xs text-fp-ink leading-snug">{n.headline}</div>
                                    <div className="font-mono text-[9px] text-fp-muted uppercase tracking-wider mt-1">{n.source} · {n.date}</div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
